import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'
import Link from '../../helper/link'

interface Props {
    message?: {
        args: {
            wt: number
        }
    }
}

export default class TriggerDeprecation extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = (
            <p>
                This trace triggers the Symfony Deprecation API <code>trigger_deprecation()</code> for a significant time. This is a
                significant waste for a production application and should be fixed in one of several ways:
            </p>
        )
        if (message) {
            const { args } = message
            intro = (
                <p>
                    This trace triggers the Symfony Deprecation API <code>trigger_deprecation()</code> for a total of{' '}
                    <Milliseconds value={args.wt} /> ms. This is a significant waste for a production application and should be fixed in one
                    of several ways:
                </p>
            )
        }

        return (
            <div>
                <ol>
                    <li>
                        If your own application code triggers the deprecations, its best to fix them. Use the{' '}
                        <a
                            href={
                                'https://support.tideways.com/documentation/features/fixing-issues/deprecations.html?utm_medium=app&utm_source=bottlenecks&utm_campaign=deprecations'
                            }
                            target={'_blank'}
                            rel={'noreferrer'}
                        >
                            deprecation tracking in Tideways
                        </a>{' '}
                        to view these deprecations to the Tideways UI or check the Symfony log files.
                    </li>
                    <li>
                        If the deprecations are triggered by third party libraries using Symfony APIs, check if you can upgrade them to
                        newer versions that do not trigger the deprecations anymore.
                    </li>
                    <li>
                        Disable the deprecation tracking in the Symfony ErrorHandler. As of up to Symfony 7.1 this is not a straightforward
                        setting, but{' '}
                        <a
                            href="https://tideways.com/profiler/blog/using-composer-patches-to-fix-performance-in-third-party-php-libraries-such-as-symfony-errorhandler?utm_medium=app&utm_source=bottlenecks&utm_campaign=patch_error_handler"
                            target="_blank"
                            rel={'noreferrer'}
                        >
                            needs to be patched via Composer patches as discussed in our blog post here
                        </a>
                        .
                    </li>
                </ol>

                {message ? (
                    <p>
                        <Link route="XhprofProfilerBundle.Profile.callgraph" query={{ fn: 'trigger_deprecation' }}>
                            View trigger_deprecation() in Call Graph
                        </Link>
                    </p>
                ) : null}
            </div>
        )
    }
}
